import React, { useState } from "react";
import { Box, Paper, Stack, Tab, Tabs, Typography } from "@mui/material";
import Sidebar from "../Administrador/AdminPanel/Sidebar";
import TopBar from "../Administrador/AdminPanel/TopBar";
import EnterpriseConfig from "./EnterpriseConfig";
import EnterpriseUsers from "./EnterpriseUsers";
import EnterpriseMail from "./EnterpriseMail";
import EnterpriseTemplates from "./EnterpriseTemplates";
import { useAuth } from "../../context/AuthContext";
import { useDashboardTheme } from "../../context/DashboardThemeContext";

const EnterprisePanel = () => {
  const { user } = useAuth();
  const { dashboardTheme } = useDashboardTheme();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [tabValue, setTabValue] = useState(0);

  const isSuper = user?.role === "super_admin";

  const tabs = [
    "General",
    "Usuarios",
    "Facturación Electrónica",
    "Correos",
    "Plantillas",
  ];

  const handleTabChange = (_event, newValue) => {
    setTabValue(newValue);
  };

  const selectedTabTextColor =
    dashboardTheme.theme_mode === "dark"
      ? dashboardTheme.table_header_text_color
      : dashboardTheme.primary_color;

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: dashboardTheme.dashboard_background,
        display: "flex",
        color: dashboardTheme.text_color,
        overflowX: "hidden",
      }}
    >
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <TopBar
          sidebarOpen={sidebarOpen}
          onToggleSidebar={() => setSidebarOpen((prev) => !prev)}
        />

        <Box
          component="main"
          sx={{
            flex: 1,
            width: "100%",
            p: { xs: 1.5, sm: 2, md: 3 },
          }}
        >
          <Box
            sx={{
              width: { xs: "100%", lg: "95%" },
              mx: "auto",
              mt: { xs: 1, md: 1.5 },
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: 24, sm: 26, md: 30 },
                fontWeight: 600,
                color: dashboardTheme.primary_color,
                mb: { xs: 1.5, md: 2 },
                lineHeight: 1.2,
              }}
            >
              Mi Compañía
            </Typography>

            <Paper
              elevation={0}
              sx={{
                borderRadius: { xs: "10px", md: "12px" },
                overflow: "hidden",
                border: `1px solid ${dashboardTheme.border_color}`,
                bgcolor: dashboardTheme.card_background,
                boxShadow:
                  dashboardTheme.theme_mode === "dark"
                    ? "none"
                    : "0 4px 10px rgba(0,0,0,0.1)",
              }}
            >
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons={false}
                allowScrollButtonsMobile
                sx={{
                  minHeight: { xs: 52, md: 56 },
                  bgcolor: dashboardTheme.table_header_color,
                  px: { xs: 0.6, sm: 1 },
                  pt: 0.8,
                  "& .MuiTabs-flexContainer": {
                    gap: { xs: 0.7, sm: 1.2 },
                    alignItems: "flex-end",
                  },
                  "& .MuiTabs-indicator": {
                    display: "none",
                  },
                  "& .MuiTab-root": {
                    color: dashboardTheme.table_header_text_color,
                    textTransform: "none",
                    fontWeight: 600,
                    fontSize: { xs: 13, sm: 14 },
                    minHeight: { xs: 46, md: 48 },
                    minWidth: "auto",
                    px: { xs: 1.4, sm: 2.3 },
                    borderTopLeftRadius: "8px",
                    borderTopRightRadius: "8px",
                    transition: "all 0.2s ease",
                    opacity: 1,
                    whiteSpace: "nowrap",
                  },
                  "& .MuiTab-root.Mui-selected": {
                    bgcolor: dashboardTheme.card_background,
                    color: selectedTabTextColor,
                    borderTop: `4px solid ${dashboardTheme.table_header_color}`,
                    borderLeft: `4px solid ${dashboardTheme.table_header_color}`,
                    borderRight: `4px solid ${dashboardTheme.table_header_color}`,
                    borderBottom: "none",
                    mt: "5px",
                  },
                  "& .MuiTabs-scrollButtons": {
                    color: dashboardTheme.table_header_text_color,
                  },
                }}
              >
                {tabs.map((tab) => (
                  <Tab key={tab} label={tab} />
                ))}
              </Tabs>

              <Box
                sx={{
                  p: { xs: 1.5, sm: 2, md: 3 },
                  bgcolor: dashboardTheme.card_background,
                  minHeight: { xs: 320, md: 360 },
                }}
              >
                {tabValue === 0 && (
                  <EnterpriseConfig canEditUserLimit={isSuper} />
                )}

                {tabValue === 1 && (
                  <EnterpriseUsers
                    canSeeSuperUsers={isSuper}
                    canCreateSuperUsers={isSuper}
                  />
                )}

                {tabValue === 2 && (
                  <Stack spacing={1}>
                    <Typography
                      sx={{
                        fontSize: { xs: 17, md: 18 },
                        fontWeight: 600,
                        color: dashboardTheme.text_color,
                      }}
                    >
                      Facturación Electrónica
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: 14,
                        color: dashboardTheme.muted_text_color,
                        lineHeight: 1.6,
                      }}
                    >
                      Aquí se cargará la configuración de facturación electrónica.
                    </Typography>
                  </Stack>
                )}

                {tabValue === 3 && <EnterpriseMail />}

                {tabValue === 4 && <EnterpriseTemplates />}
              </Box>
            </Paper>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default EnterprisePanel;